// extracted by mini-css-extract-plugin
export default {"android_link":"Le7es","android_badge":"M2go1","android_link_icon":"KWdTT","android_link_desc":"CgvI3"};